import { ErrorPage } from '@im/ui-lib/ErrorPage';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useTranslate } from '@im/react-localization';

export default function CustomErrorPage(
  params: Readonly<{
    errorText: string;
    navigateBack: () => void;
  }>
) {
  const translate = useTranslate();
  return (
    <Stack alignItems={'center'}>
      <ErrorPage
        data-testid="gds-vp-custom-error-page"
        errorText={params.errorText}
        message={translate('Common.CustomErrorMessage')}
      />
      <Button
        data-testid="gds-vp-custom-error-page-back"
        onClick={params.navigateBack}
        startIcon={<NavigateBeforeIcon />}
        variant="newContained"
      >
        {translate('Common.BackToPrevious')}
      </Button>
    </Stack>
  );
}
